import { render, staticRenderFns } from "./kiosk-payment.vue?vue&type=template&id=86fd2f1e&scoped=true&"
import script from "./kiosk-payment.vue?vue&type=script&lang=js&"
export * from "./kiosk-payment.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-payment.vue?vue&type=style&index=0&id=86fd2f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fd2f1e",
  null
  
)

export default component.exports